export enum Accion {
  OficioFavorable="EMITIR_OFICIO_FAVORABLE",
  ResDefinitivaFavorable="RESOLUCION_DEFINITIVA_FAVORABLE",
  ResDefinitivaNegativa="RESOLUCION_DEFINITIVA_NEGATIVA",
  SolicitarSubsanacionEmpresa="SOLICITAR_SUBSANACION_EMPRESA",
  SolicitarSubsanacionAESAN="SOLICITAR_SUBSANACION_AESAN",
  ReactivarSolicitud="REACTIVAR_SOLICITUD",
  AmpliarSubsanacion="AMPLIAR_SUBSANACION",
  CartaIncidencias="CARTA_INCIDENCIAS",
  ResDefinitivaDenegatoria="RESOLUCION_DEFINITIVA_DENEGATORIA",
  PropResolucionDenegatoria="PROPUESTA_RESOLUCION_DENEGATORIA",
  DesistirSolicitud="DESISTIR_SOLICITUD",
  PresentarAlegaciones="PRESENTAR_ALEGACIONES",
  RectificacionResFavorable="RECTIFICACION_RESOLUCION_FAVORABLE",
  //Acciones Presentaciones Comercialización
  BajaPresentacion="BAJA_PRESENTACION",
  SuspensionTemporal="SUSPENSION_TEMPORAL",
  SolicitarProrroga="SOLICITAR_PRORROGA",
  Comercializar="COMERCIALIZAR",
  CambioFechaComercializacion="CAMBIO_FECHA_COMERCIALIZACION",
  DesistirPresentacion="DESISTIR_PRESENTACION",

  ExcluirPresentacion="EXCLUIR_PRESENTACION", // Acción para excluir una presentación ya comercializada
  AceptarComercializacion="ACEPTAR_COMERCIALIZACION",//Acción de cartera para aceptar la comercialización de una presentación
  AceptarProroga="ACEPTAR_PRORROGA",//Acción de cartera para aceptar la prórroga de una presentación
  RechazarProrroga="RECHARZAR_PRORROGA",//Acción de cartera para rechazar la prórroga de una presentación
  SolicitarSubsanacionPresentacion="SOLICITAR_SUBSANACION_PRESENTACION",//Acción de cartera para solicitar subsanación de una presentación
  ConfirmarBaja="CONFIRMAR_BAJA",//Acción de cartera para confirmar la baja de una presentación
  ConfirmarSuspension="CONFIRMAR_SUSPENSION",//Acción de cartera para confirmar la suspensión de una presentación
  AnularPresentacion="ANULAR_PRESENTACION",//Acción de cartera para anular una presentación
}
